import React, { Component } from "react";

import { IimageSlideComponentProps } from "../types/props";
import { EchallengeImages, EDirection } from "../enums";
import { CHALLENGE_IMAGE_PREFIX, IMAGE_CONFIG, TITLE_CONFIG } from "../config";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import "./imageSlide.component.scss";
class ImageSlideComponent extends Component<IimageSlideComponentProps> {
  render() {
    return (
      <div className="image-slide">
        <ReactTooltip backgroundColor="rgb(0, 51, 89)" />
        <div className="image-slide--left">
          <div className="image-slide--buttons">
            <button
              className="image-slide--up"
              disabled={this.props.index === 0}
              onClick={this.up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="image-slide--down"
              disabled={this.props.last}
              onClick={this.down}
            >
              <span className="sr-only">Move Down</span>
            </button>
            <span className="image-slide--index">{this.props.index + 1}</span>
          </div>
        </div>
        <div className="image-slide--right">
          <button className="image-slide--remove" onClick={this.remove}>
            <img src={`/dist/${closeImage}`} />
            <span className="sr-only">Remove</span>
          </button>
          <h2 data-tip={this.getTitleForTooltip().length > 30 ? this.getTitleForTooltip() : null}>
            {this.renderTitle()}
          </h2>
          
          <img src={this.getImage()} />
        </div>
      </div>
    );
  }

  up = () => {
    this.props.moveSlide(this.props.index, EDirection.up);
  };
  down = () => {
    this.props.moveSlide(this.props.index, EDirection.down);
  };
  remove = () => {
    this.props.removeSlide(this.props.index);
  };
  getTitle = () => {
    const config = TITLE_CONFIG[this.props.challenge];
    if (config === undefined) {
      return `Not Configured`;
    } else return config;
  };

  getTitleForTooltip = () => {
    const title = this.getTitle();
    // Plain text for the tooltip; DOMParser builds an inert document, so nothing executes
    return new DOMParser().parseFromString(title, 'text/html').body.textContent || '';
  };

  renderTitle = () => {
    const title = this.getTitle();
    // Handle common HTML entities and tags
    if (title.includes('<sup>') && title.includes('</sup>')) {
      // Split by <sup> tags and render accordingly
      const parts = title.split(/(<sup>.*?<\/sup>)/);
      return parts.map((part, index) => {
        if (part.startsWith('<sup>') && part.endsWith('</sup>')) {
          // Extract content between sup tags
          const supContent = part.replace(/<\/?sup>/g, '');
          return <sup key={index}>{supContent}</sup>;
        }
        return part;
      });
    }
    
    // If no special HTML, return as is
    return title;
  };
  getImage = () => {
    const config = IMAGE_CONFIG[this.props.challenge];
    if (config === undefined) {
      return `${CHALLENGE_IMAGE_PREFIX}fake_placeholder.png`;
    } else if (config === EchallengeImages.screenCapture) {
      return this.props.image;
    } else {
      return `${CHALLENGE_IMAGE_PREFIX}${config}`;
    }
  };
}

export default ImageSlideComponent;
